import React from 'react';

const IconDiscountBogo = () => {
  return (
    <svg
      width='30'
      height='30'
      viewBox='0 0 30 30'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className='bogoIcon'
    >
      <path
        d='M13.125 17.8125C13.1247 17.564 13.0258 17.3257 12.85 17.15C12.6743 16.9742 12.436 16.8753 12.1875 16.875H11.25V18.75H12.1875C12.436 18.7497 12.6743 18.6508 12.85 18.475C13.0258 18.2993 13.1247 18.061 13.125 17.8125Z'
        fill='#2F3D48'
      />
      <path
        d='M25.5842 23.5288C27.6949 20.9071 28.7571 17.5951 28.565 14.2349C28.3728 10.8746 26.94 7.70533 24.5442 5.34133C22.1484 2.97734 18.9602 1.58699 15.5977 1.43977C12.2352 1.29254 8.93773 2.39893 6.34448 4.54448C3.75124 6.69003 2.04689 9.72194 1.56179 13.0526C1.07668 16.3832 1.84537 19.7753 3.71886 22.5714C5.59235 25.3675 8.43721 27.3686 11.702 28.1866C14.9669 29.0047 18.4191 28.5815 21.3897 26.9991L26.1019 28.5694C26.1497 28.5857 26.1998 28.594 26.2502 28.5939C26.3215 28.5939 26.3917 28.5777 26.4557 28.5464C26.5197 28.5152 26.5758 28.4698 26.6196 28.4137C26.6634 28.3575 26.6939 28.2922 26.7087 28.2225C26.7235 28.1529 26.7222 28.0807 26.7049 28.0117L25.5842 23.5288Z'
        fill='#2F3D48'
      />
      <path
        d='M7.70764 13.4749V11.7259H10.7546V19.7559H8.79664V13.4749H7.70764ZM17.8054 16.7529H15.8914V18.7109H14.1094V16.7529H12.1954V15.0699H14.1094V13.1009H15.8914V15.0699H17.8054V16.7529ZM18.7506 13.4749V11.7259H21.7976V19.7559H19.8396V13.4749H18.7506Z'
        fill='white'
      />
    </svg>
  );
};

export default IconDiscountBogo;
